import axios from 'axios'
import environment from '../config/environment'
import CryptoJS from 'crypto-js'
import { secretCookie, getSearchCookie } from '../tools/tool'
export const cw1 = environment.cw1Url
export const api5 = environment.api5Url
export const api3 = environment.api3Url
export const pcapi = environment.pcUrl
export const safeUrl = environment.safeUrl
const code = '100001'
const key = 'gk6tyNS6o*R,w81kZnPAm*7@+a85-9uG'
const cookieName = CryptoJS.MD5(code + key).toString()
// cw1.gxnw.cn 入驻申请测试地址
// api3.gxnw.cn 获取评论接口测试地址
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded' // 跨域

// Access-Control-Allow-Credentials设置为true的情况下 ,Access-Control-Allow-Origin不能设置为*
var isIE = navigator.userAgent.search("Triden") != -1 || navigator.userAgent.search("MSIE") != -1; //判断是否为IE浏览器
var isChineseDomain = window.location.host.search(".xn--fiqs8s") != -1 || window.location.host.search(".中国") != -1;//判断是否中文域名
if (!(isIE && isChineseDomain)) {
    axios.defaults.withCredentials = true
}


// 登录接口
export const loginAPI = () => { return axios.post(`${pcapi}/index/CheckLoginStatus`).then(res => res.data) }
// 获取ACCESS_TOKEN接口
export const getTokenAPI = params => {
    // 请求接口的时候监测有没有cookie没有的话重新种
    if (getSearchCookie(cookieName).length < 1) {
        secretCookie()
    }
    return axios.post(`${api3}/AccessToken/index`, params).then(res => res.data)
}
// 首页推荐阅读及轮播
export const getRecommendedReadingAPI = params => { return axios.post(`${api3}/Utensil/GetAdv`, params).then(res => res.data) }
// 企业查询接口
export const getCompanyListAPI = params => { return axios.post(`${api3}/company/search`, params).then(res => res.data) }
// 网站查询接口
export const getWebsiteListAPI = params => { return axios.post(`${api3}/Search/WebSite`, params).then(res => res.data) }
// 网站详情
export const getWebDetailAPI = params => { return axios.post(`${api3}/detail/webDetail`, params).then(res => res.data) }
// 商品查询接口
export const getProductListAPI = params => { return axios.post(`${api3}/directPurchase/search`, params).then(res => res.data) }
// // 关注：统计关注接口/已有加入对比的列表及其数量
// export const getAttentionAPI = () => { return axios.post(`${pcapi}/contrast/ajaxContrast`).then(res => res.data) }
// // 点击对比
// export const getComparisonAPI = () => { return axios.post(`${pcapi}/member/CompanyCount`).then(res => res.data) }
// 获取对比和关注
export const getAttentionAndComparisonAPI = () => { return axios.post(`${pcapi}/member/FocusContrast`).then(res => res.data) }
// 对比：删除接口
export const removeContrastAPI = params => { return axios.get(`${pcapi}/member/ContrastDelete` + '?company_id=' + params).then(res => res.data) }
// 对比：加入接口
export const addContrastAPI = params => { return axios.get(`${pcapi}/member/contrast` + '?company_id=' + params.company_id).then(res => res.data) }
// 最新上市企业列表
export const getListedCompanyNewListAPI = params => { return axios.post(`${api3}/company/listedCompanyNewList`, params).then(res => res.data) }
// 上市企业列表
export const getListedCompanyListAPI = params => { return axios.post(`${api3}/company/listedCompanyList`, params).then(res => res.data) }
// 机构列表
export const getInstitutionSorlListAPI = params => { return axios.post(`${api3}/search/institutionSorlList`, params).then(res => res.data) }
// 根据公司id获取名片所需信息
export const getCompanyIdAPI = params => { return axios.post(`${api3}/search/getBusinessCardInfoByCompanyId`, params).then(res => res.data) }
// 企业列表关键词信息
export const getSearchExampleAPI = params => { return axios.post(`${api3}/company/searchExample`, params).then(res => res.data) }

// 共用的 传个url过来就行
export const fetch = (params, url) => { return axios.post(url, params).then(res => res.data) }


// 公信码详情
export const getGxCodeAPI = params => { return axios.post(`${api3}/Gxcode/GetGxcodeDetail`, params).then(res => res.data) }

// 获取安全服务列表
export const getSafeListAPI = params => { return axios.post(`${safeUrl}/qxy/NetworkSafe/list`, params).then(res => res.data) }

// 获取安全列表详情
export const getSafeListDetailAPI = params => {
    return axios.post(`${safeUrl}/qxy/NetworkSafe/detail`, params).then(res => res.data)
}





// WEBPACK FOOTER //
// ./src/request/api.js